<div class="modal-header">
  <h4 class="modal-title"><i class="fa fa-picture-o me-2"></i>Galeria de imagens RCS</h4>
  <button type="button" class="btn-close" aria-label="Fechar" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body rcs-scope rcs-stack">
  <div class="rcs-row rcs-row--between">
    <input type="search" class="form-control rcs-search" [(ngModel)]="search"
      placeholder="Buscar por nome ou categoria" aria-label="Buscar imagem" data-testid="rcs-gallery-search" />
    <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="showUpload = !showUpload"
      data-testid="rcs-gallery-toggle-upload">
      Nova imagem <i class="fa fa-plus"></i>
    </button>
  </div>

  <div class="sf-btn-group rcs-tabs" role="tablist" aria-label="Categorias">
    <button type="button" class="sf-btn sf-btn--sm" *ngFor="let item of categories" role="tab"
      [class.is-active]="category === item" [attr.aria-selected]="category === item" (click)="category = item">
      {{ item }}
    </button>
  </div>

  <app-rcs-media-upload *ngIf="showUpload" (uploaded)="onUploaded($event)" (cancelled)="showUpload = false">
  </app-rcs-media-upload>

  <app-skeleton *ngIf="loading" variant="card" [count]="3" label="Carregando a galeria"></app-skeleton>

  <div class="rcs-notice rcs-notice--bad" *ngIf="failed">
    <i class="fa fa-exclamation-triangle"></i>
    <span>Não foi possível carregar a galeria. <a href="" (click)="$event.preventDefault(); load()">Tentar de novo</a></span>
  </div>

  <div class="rcs-empty" *ngIf="!loading && !failed && !visible.length" data-testid="rcs-gallery-empty">
    <i class="fa fa-picture-o"></i>
    <strong>Nenhuma imagem encontrada</strong>
    <span>Busque por outro termo ou envie uma imagem nova.</span>
  </div>

  <div class="rcs-gallery" *ngIf="!loading && visible.length">
    <button type="button" class="rcs-gallery__item" *ngFor="let media of visible"
      [class.is-selected]="media.url === selectedUrl" (click)="choose(media)" data-testid="rcs-gallery-item">
      <div class="rcs-gallery__media">
        <img [src]="media.url" [alt]="media.title" loading="lazy" />
        <span class="rcs-gallery__tag rcs-gallery__tag--left" *ngIf="media.category">{{ media.category }}</span>
        <span class="rcs-gallery__tag rcs-gallery__tag--right" *ngIf="media.width && media.height">
          {{ media.width }}×{{ media.height }}
        </span>
      </div>
      <div class="rcs-gallery__info"><h4 [title]="media.title">{{ media.title }}</h4></div>
    </button>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="sf-btn sf-btn--secondary" (click)="choose(null)" data-testid="rcs-gallery-none">
    Sem imagem
  </button>
  <button type="button" class="sf-btn sf-btn--ghost" (click)="activeModal.dismiss()">Fechar</button>
</div>
